import { render, staticRenderFns } from "./LevyComponentsWidget.vue?vue&type=template&id=45851560&"
import script from "./LevyComponentsWidget.vue?vue&type=script&lang=js&"
export * from "./LevyComponentsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports